import { useQuery } from "@tanstack/react-query";
import { fidexaPayWalletServices } from "../fidexaPayWalletServices";
import type { FidexaPayAvailability } from "../fidexaPayWalletTypes";

const DEFAULT_AVAILABILITY: FidexaPayAvailability = {
  enabled: false,
  companyIds: [],
};

/**
 * Diz se o Fidexa Pay está liberado para o usuário e em quais lojas. Mesmo
 * padrão de `useCampaignAvailability`: enquanto carrega (ou se falhar) vale
 * "desligado", e o gate de verdade é o do backend (404 por loja).
 */
export const useFidexaPayAvailability = () => {
  const { data, isPending } = useQuery({
    queryKey: ["fidexa-pay-availability"],
    queryFn: fidexaPayWalletServices.getAvailability,
    // A allowlist muda no BackOffice: revalida a cada minuto e ao voltar
    // para a aba, para uma loja removida sair do menu sem recarregar (o
    // backend já responde 404 na hora).
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  return {
    availability: data ?? DEFAULT_AVAILABILITY,
    isLoadingAvailability: isPending,
  };
};
